<template>
  <b-container fluid>
    <b-row class="mb-5">
      <b-col lg="2">
        <div class="mb-3">
          <b-button
            variant="primary"
            @click="showCreateEditBallonModal"
            block
            class="mb-3"
          >
            Nouveau ballon
          </b-button>
        </div>
      </b-col>

      <b-col lg="10">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button @click="getAllBallons" class="mr-1">All</b-button>
            <b-button
              :variant="dark ? 'dark' : 'light'"
              @click="dark = !dark"
              class="mr-1"
              ><b-icon :icon="dark ? 'sun' : 'moon'" aria-hidden="true"></b-icon
            ></b-button>
            <!-- <b-button variant="info" @click="stickyHeader">Sticky header</b-button> -->
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          responsive
          :sticky-header="isStickyHeader"
          :dark="dark"
          :filter="filter"
          :items="ballons"
          :fields="fields"
        >
          <template #cell(actions)="row">
            <b-button
              @click="showDeleteModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="danger"
              block
            >
              Supprimer
            </b-button>
            <b-button
              @click="showEditModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="warning"
              block
            >
              Modifier
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <create-edit-ballon-modal
      v-if="isShowBallonModal"
      :ballon="ballon"
    ></create-edit-ballon-modal>
  </b-container>
</template>

<script>
import CreateEditBallonModal from "./ModalCreateEditBallon.vue";

export default {
  name: "BallonManagement",
  data() {
    return {
      ballons: [],
      ballon: {},
      windowHeight: window.innerHeight - 120,
      isStickyHeader: window.innerHeight - 120 + "px",
      dark: true,
      isShowBallonModal: false,
      filter: "",
      fields: [
        {
          key: "id",
          sortable: true,
        },
        {
          key: "ref",
          sortable: true,
        },
        {
          key: "isComplete",
          sortable: true,
        },
        {
          key: "typeId",
          sortable: true,
        },

        {
          label: "Nom",
          key: "name",
          sortable: true,
        },
        {
          key: "actions",
          sortable: true,
        },

        {
          label: "Marque",
          key: "brand",
          sortable: true,
        },
        {
          label: "Volume total",
          key: "volumeTotal",
          sortable: true,
        },
        {
          label: "Volume total",
          key: "volumeTotal",
          sortable: true,
        },
        {
          label: "Hauteur",
          key: "height",
          sortable: true,
        },
        {
          label: "Isolant",
          key: "isolant",
          sortable: true,
        },
        {
          label: "Epaisseur",
          key: "thickness",
          sortable: true,
        },
      ],
    };
  },
  components: {
    CreateEditBallonModal,
  },
  mounted() {
    console.log("ballons component");
    this.getAllBallons();

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-newBallon") {
        this.getAllBallons();
        this.isShowBallonModal = false;
      }
    });
  },
  methods: {
    getAllBallons() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/ballon/getAllBallons", {
        method: "get",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          // console.log(json);
        
          // this.ballons = json.filter((item) => item.email.includes("solaire"));
          this.ballons = json;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteBallonById(ballon) {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/ballon/removeBallon", {
        method: "delete",
        body: JSON.stringify({
          id: ballon.id,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then(() => {
          this.getAllBallons();
        })

        .catch((err) => {
          console.log(err);
        });
    },
    showDeleteModal(ballon) {
      this.$bvModal
        .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cet utilisateur ?")
        .then((value) => {
          if (value) {
            this.deleteBallonById(ballon);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    showEditModal(ballon) {
      this.ballon = ballon;
      this.isShowBallonModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newBallon");
      }, 100);
    },
    showCreateEditBallonModal() {
      this.ballon = null;

      this.isShowBallonModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newBallon");
      }, 100);
    },
  },
  watch: {},
  computed: {
    style() {
      return {
        top: this.top + "px",
        left: this.left + "px",
      };
    },
  },
};
</script>
<style>
.context-menu {
  position: fixed;
  background: white;
  z-index: 999;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}
</style>
